import { Typography } from '@mui/material'

// Types
import type { TypographyProps } from '@/types/components/atoms/typography'

const ParagraphTypographyAtom = (props: TypographyProps) => {
	// Props
	const { text, textAlign } = props

	return (
		<Typography variant="body2" sx={{ textAlign }}>
			{text}
		</Typography>
	)
}

export default ParagraphTypographyAtom
